import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MultipleChoiceView = ({ allData }) => {
  const [questions, setQuestions] = useState([]);
  const navigate = useNavigate();


  // Initialize questions
  useEffect(() => {
    if (allData?.questions) {
      const dataList = allData.questions.map((item) => ({
        question_id: item.questionId,
        question_text: item.questionText,
        options: item.options.map((option, idx) => ({
          option_text: option,
        })),
        points: item.marks || 1,
        correctAnswer: item.correctAnswer,
        submittedAnswer: item.submittedAnswer,
      }));
      setQuestions(dataList);
    }
  }, [allData?.questions]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="assignment-header mb-10 mb-sm-20 mb-md-24">
        <h3 className="ah-heading-04 fw-bold">{allData?.assignmentTitle}</h3>
        <p>{allData?.passage || "No description available"}</p>
        <div className="item ah-text-md fw-bold theme-color text-end">
          Duration:{" "}
          <span className="fw-semibold black-100 opacity-50">
            {allData?.duration} min
          </span>
        </div>
      </div>

      <div className="card-default-style px-12 px-sm-20 px-md-30 py-12 overflow-x-hidden">
        <div className="assignment">
          <div className="assignment-inner px-5 py-5">
            <ul className="p-0 list-unstyled mb-0">
              {questions?.map((question, index) => (
                <li key={question.question_id}>
                  <div className="d-flex align-items-start justify-content-between flex-column-reverse flex-sm-row gap-2 gap-lg-3 gap-xl-5">
                    <div className="question mb-10 mb-sm-20 mb-md-32">
                      <div className="question-title ah-text-md fw-bold mb-14">
                        {index + 1}. {question.question_text}
                      </div>
                      {question?.options?.map((item, idx) => {
                        const isCorrect = question.correctAnswer === idx + 1;
                        const isSubmitted = question.submittedAnswer == idx + 1;
                        const isWrong = isSubmitted && !isCorrect;

                        return (
                          <label
                            key={idx}
                            className={`custom-radio ah-text-base fw-normal ps-30 mb-14 d-block position-relative ${
                              isCorrect ? "text-success" : isWrong ? "text-danger" : ""
                            }`}
                          >
                            {item.option_text}
                            <input
                              type="radio"
                              name={`question_${question.question_id}`}
                              value={idx + 1}
                              checked={isSubmitted}
                              disabled
                              onChange={() => {}} // Empty handler to prevent warnings
                            />
                            <span className="checkmark"></span>
                          </label>
                        );
                      })}
                    </div>
                    <span className="points flex-shrink-0 h-auto px-29 py-8 ah-text-xs fw-semibold">
                      {question.points} Point
                      {question.points !== 1 ? "s" : ""}
                    </span>
                  </div>
                </li>
              ))}
            </ul>

            <div className="mt-20">
              <button
                className="btn btn-primary no-shadow px-50 py-15"
                type="button"
                onClick={goBack}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MultipleChoiceView;